<template>
  <div class="mx-5">
    <div
      class="mt-3 md:mt-0 md:ml-0 border border-1 rounded-xl p-3 mb-3 relative overflow-hidden text-[1rem] leading-[1.5rem]"
      :class="{
        'bg-[#EAE8E5] border-[#C0C0C0]': !update.isNew,
        'bg-[#F6F4F0] border-[#3C3A36]': update.isNew,
      }"
    >
      <div @click="navigate(update)">
        <div class="font-aktiv-grotest-regular">
          <div class="flex flex-row justify-between items-center mb-3">
            <p
              class="tracking-wide text-[1rem] font-bold leading-[1.5rem] pr-3 text-[#1D1D1D] font-aktiv-grotesk w-[227px]"
            >
              <html-to-vue :html="update.title" />
            </p>
            <div
              v-if="update.postedTime != ''"
              class="flex flex-row items-center justify-end font-aktiv-grotesk"
            >
              <p class="tracking-wide text-xs text-[#1D1D1D]">
                {{ formattedPostedTime }}
              </p>
              <div v-if="update.isNew" class="rounded-full bg-[#FEC629] ml-3 w-[8px] h-[8px]"></div>
            </div>
          </div>
          <p
            class="tracking-wide text-[1rem] leading-[1.5rem] text-[#353535] font-aktiv-grotesk mb-3"
          >
            <html-to-vue :html="update.descriptionShort" />
          </p>
          <div class="flex flex-row justify-between items-center">
            <div></div>
            <div class="flex flex-row items-center gap-2">
              <div class="text-[0.875rem] leading-[1.25rem] text-[#78634F] font-bold">
                Read More
              </div>
              <div>
                <img class="w-[20px] h-[20px]" src="/assets/icons/updates/read-more.svg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatPostedTime } from '@/utils/date';

// Memoization cache for formatPostedTime
const formatCache = new Map();
const CACHE_SIZE_LIMIT = 100;

export default {
  name: 'UpdatesCard',
  components: {},
  props: {
    update: {
      type: Object,
      default: () => {},
    },
    hash: {
      type: Boolean,
      default: () => {},
    },
  },
  computed: {
    // Memoized computed property for formatted posted time
    formattedPostedTime() {
      const time = this.update.postedTime;
      if (!time) return '';

      // Check cache first
      if (formatCache.has(time)) {
        return formatCache.get(time);
      }

      const finalDateString = formatPostedTime(time);

      // Cache the result (with size limit to prevent memory leaks)
      if (formatCache.size >= CACHE_SIZE_LIMIT) {
        // Remove oldest entry (simple FIFO)
        const firstKey = formatCache.keys().next().value;
        formatCache.delete(firstKey);
      }
      formatCache.set(time, finalDateString);

      return finalDateString;
    },
  },
  methods: {
    navigate(update) {
      this.$emit('navigate', update);
    },
  },
};
</script>
<style scoped>
p >>> a {
  color: #00aae4;
  font-weight: 600;
  text-decoration: underline;
}
</style>
